/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ChangeRotorWingShiftsRequest } from '../../models/change-rotor-wing-shifts-request';
import { RotorWingShiftAssignmentResultResponse } from '../../models/rotor-wing-shift-assignment-result-response';

export interface ChangeRotorWingShifts$Params {
      body: ChangeRotorWingShiftsRequest
}

export function changeRotorWingShifts(http: HttpClient, rootUrl: string, params: ChangeRotorWingShifts$Params, context?: HttpContext): Observable<StrictHttpResponse<RotorWingShiftAssignmentResultResponse>> {
  const rb = new RequestBuilder(rootUrl, changeRotorWingShifts.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RotorWingShiftAssignmentResultResponse>;
    })
  );
}

changeRotorWingShifts.PATH = '/api/scheduler/daily-line-schedule/rotor-wing/assignments';
